import { createContext, useContext } from "react";
import { action, makeAutoObservable, makeObservable, observable, runInAction } from "mobx";
import { postMethodData, getMethodData, putMethod, delMethod, patchMethodData } from "../../ApiMethods/api";
import { toast } from "react-toastify";
const SEO_URL = process.env.REACT_APP_SEO_URL;





export class WebsiteStore {

    Token = null;
    Website = [];
    WebsiteLoadercirlce = false;
    PageLoader = false;
    header = "";
    footer = "";
    meta_description = "";
    Page_id = "";
    page_data = "";
    meta = "";
    pagename = "";
    OtherPageList = [];
    ContactPageListLoader = false;
    OtherPageLoader = false;
    type = "";
    filterSearch = "";
    PaginationPage = "1";
    TotalPages = "";
    WebsiteDimiensions = ""
    crop = {};
    errLoadWebsite = "";
    LoadWebsite = false;
    delateLoader = false;
    nolist = false;
    Websitepopup = false;
    deletepopup = false;
    Websitename = "";
    status = "1";
    statesid = "";
    Websiteid = [];
    seoUrl = "";
    statuspopup = false;
    addWebsitename = "";
    imageurl = "";
    logoimage = "";
    Websiteimage = "";
    Base64logoImage = "";
    Base64WebsiteImage = "";
    logofile = [];
    allWebsite = [];
    alldeactivate = 'false';
    isWebsiteUpdated = "false";
    isLogoUpdated = "false"
    checkeddd = '';

    DetailPageList = {
        "page_name": "",
        "meta_title": "",
        "meta_description": ""
    };
    ContactPageContent = {
        "address": "",
        "contact": "",
        "email": ""
    };
    saved = false;

    constructor(isloading = false) {

        makeAutoObservable(this, {
            addWebsitename: observable,
            status: observable,
            errorMessages: observable,
            setaddWebsitename: action,
            getstatus: action,
            resetErrors: action,
        });
        this.Token = localStorage.getItem("Admintoken");

        if (isloading.isloading) {
            this.getContactPageList();
            //   this.getStateList();
            return
        }
        if (isloading.OtherPage) {
            this.getOtherPageList();
        }
        if (isloading.getOtherPageDetails) {
            this.getOtherPageDetails(isloading.id);
            // this.getContactPageContentList();
            return
        }
    }
    //All Clear 
    allclear = () => {
        this.filterSearch = ""
        this.getFilterWebsite();
        //   this.status="";
        //   this.statesid="";
    }
    setimage = (text, type) => {
        this.imageurl = URL.createObjectURL(text[0]);
    }

    setalldeactivate = (text) => {
        console.log(text);
        this.alldeactivate = !this.alldeactivate;
    };

    getid = (text) => {
        this.Websiteid.push(text);
    };



    // status popup
    setstatuspopup = () => {
        this.statuspopup = !this.statuspopup;
    };


    setallWebsite = (text) => {
        this.allWebsite = text;
    }

    // get status 
    getstatus = (text) => {
        this.status = text;
    };

    //get city name
    getWebsitename = (text) => {
        this.Websitename = text;
    };

    setaddWebsitename = (text) => {
        this.addWebsitename = text;
    };
    setCrop = (text) => {
        this.crop = text;
    };

    setWebsiteDimiensions = (text) => {
        this.WebsiteDimiensions = text;
    };

    setlogofile = (e) => {
        this.logofile = e;
        console.log(this.logofile);
    };

    setWebsitepopup = (e) => {
        this.Websitepopup = e;
    };
    setdeletepopup = (e) => {
        this.deletepopup = e;
    };
    setdelateLoader = (e) => {
        this.delateLoader = e;
    }
    getToken = (e) => {
        this.Token = e;
    }
    gettype = (e) => {
        this.type = e;
    }
    getseourl = (text) => {
        // console.log(`https://demo.e-kart.com/${text}`);
        this.seoUrl = text;
    };
    getlogoimage = (text) => {
        console.log("checking in the Website", text);
        this.logoimage = text;
    };
    getWebsite_image = (text) => {
        console.log(text);
        this.Websiteimage = text;
    };
    SetfilterSearch = (text) => {
        this.filterSearch = text;
    };
    setPaginationPage = (text) => {
        this.PaginationPage = text;
    };
    setPage_id = (text) => {
        this.Page_id = text;
    };
    SetTotalPages = (text) => {
        this.TotalPages = text;
    };
    setchecked = (text) => {
        this.checkeddd = text;
    };
    setisWebsiteUpdated = (text) => {
        this.isWebsiteUpdated = text;
    };
    setisLogoUpdated = (text) => {
        this.isLogoUpdated = text;
    };

    isBase64 = (str) => {
        try {
            return btoa(atob(str)) === str;
        } catch (err) {
            return false;
        }
    };

    set_Header = (text) => {
        console.log("checkkkkkkkkkkkkkkkkinggggggggggggggggggggg", text);
        this.header = text
    };

    setmeta = (text) => {

        this.meta = text

    };

    setmeta_description = (text) => {

        this.meta_description = text

    };

    setpage_data = (text) => {
        console.log(text);
        this.page_data = text

    };

    setpagename = (text) => {

        this.pagename = text

    };
    set_footer = (text) => {
        this.footer = text
    };
    SetDetailPageList = (WebsiteDetail) => {
        this.DetailPageList = {
            ...this.DetailPageList,
            meta_title: WebsiteDetail.meta_title || "",
            page_name: WebsiteDetail.page_name || "",
            meta_description: WebsiteDetail.meta_description || "",

        };
    };
    setContactPageContent = (WebsiteDetail) => {
        console.log(WebsiteDetail);
        // if (WebsiteDetail == null) {
            this.ContactPageContent = {
                ...this.ContactPageContent,
                address: WebsiteDetail?.address || "",
                contact: WebsiteDetail?.contact || "",
                email: WebsiteDetail?.email || "",

            };
        // }

    };
    // setContactPageContent = (text) => {
    //     this.ContactPageContent = text;
    //     console.log("setContactPageContent", this.ContactPageContent.Websitename);
    // };
    base64toFile(base64Data, fileName, mimeType) {
        if (base64Data) {
            const byteCharacters = atob(base64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters?.length; offset += 512) {
                const slice = byteCharacters?.slice(offset, offset + 512);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const file = new File(byteArrays, fileName, { type: mimeType });

            return file;
        }

    }

    // get Website list
    getWebsiteList = () => {
        runInAction(() => {
            this.WebsiteLoader = true;
            this.errLoadWebsite = "";
            this.saved = false;
            this.nolist = false;
            this.Website = [];
        });
        getMethodData(`/api/v1/admin/Website/get-list`, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.WebsiteLoader = false;
                        this.errLoadWebsite = resp?.data?.message
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.WebsiteLoader = false;
                        this.errLoadWebsite = resp?.data?.message;
                        if (resp?.data?.data.length === 0) {
                            this.nolist = true;
                        } else {
                            this.nolist = false;
                        }
                        this.Website = resp?.data?.data;
                        this.SetTotalPages(resp?.data?.totalPage)
                        this.saved = false;
                        // this.status = true;
                    });
                    return;
                }
                runInAction(() => {
                    this.LoadWebsite = false;
                    this.errLoadWebsite = resp?.data?.message;
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.WebsiteLoader = false;
                    if (!error.response) {
                        this.errLoadWebsite = error?.message;
                        toast.error(error?.message);
                    }
                    this.errLoadWebsite = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
    };

    // get Website type list
    getContactPageList = () => {
        runInAction(() => {
            this.WebsiteLoadercirlce = true;
            this.errLoadWebsite = "";
            this.saved = false;
            this.nolist = false;
            this.ContactPageContent = [];
        });
        getMethodData(`/api/v1/admin/website-page/contact-info/get-list`, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.WebsiteLoadercirlce = false;
                        this.errLoadWebsite = resp?.data?.message
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.WebsiteLoadercirlce = false;
                        this.errLoadWebsite = resp?.data?.message;
                        if (resp?.data?.data?.length === 0) {
                            this.nolist = true;
                        } else {
                            this.nolist = false;
                        }
                        this.setContactPageContent(resp.data.data);
                        this.SetTotalPages(resp?.data?.totalPage)
                        this.saved = false;
                        // this.status = true;
                    });
                    return;
                }
                runInAction(() => {
                    this.LoadWebsite = false;
                    this.errLoadWebsite = resp?.data?.message;
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.WebsiteLoadercirlce = false;
                    if (!error.response) {
                        this.errLoadWebsite = error?.message;
                        toast.error(error?.message);
                    }
                    this.errLoadWebsite = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
    };
    // get Website type list
    getOtherPageDetails = (id) => {
        runInAction(() => {
            this.PageLoader = true;
            this.errLoadWebsite = "";
            this.saved = false;
            this.nolist = false;
            this.ContactPageContent = [];
        });
        const formData = new FormData();

        formData.append('record_id', id);


        postMethodData(`/api/v1/admin/website-page/other-pages/form`, formData, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.PageLoader = false;
                        this.errLoadWebsite = resp?.data?.message
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.PageLoader = false;
                        this.errLoadWebsite = resp?.data?.message;
                        if (resp?.data?.data.length === 0) {
                            this.nolist = true;
                        } else {
                            this.nolist = false;
                        }
                        this.SetDetailPageList(resp.data.data);
                        this.setpage_data(resp.data.data.page_data)
                        this.SetTotalPages(resp?.data?.totalPage)
                        this.saved = false;
                        // this.status = true;
                    });
                    return;
                }
                runInAction(() => {
                    this.LoadWebsite = false;
                    this.errLoadWebsite = resp?.data?.message;
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.PageLoader = false;
                    if (!error.response) {
                        this.errLoadWebsite = error?.message;
                        toast.error(error?.message);
                    }
                    this.errLoadWebsite = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
    };

    updateOtherPageDetails = (id) => {
        runInAction(() => {
            this.PageLoader = true;
            this.errLoadWebsite = "";
        });

        const formData = new FormData();
        const strippedContent = this.page_data.replace(/<[^>]*>/g, '');

        formData.append('page_name', this.DetailPageList.page_name);
        formData.append('meta_title', `${this.DetailPageList.meta_title}`);
        formData.append('meta_description', this.DetailPageList.meta_description);
        formData.append('page_data', strippedContent);
        formData.append('record_id', id);
        // formData.append('isWebsiteUpdated', false  );
        // formData.append('isLogoUpdated', true  );


        postMethodData(`/api/v1/admin/website-page/other-pages/edit`,
            formData,
            this.Token
        )
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.addloadcity = false;
                        this.PageLoader = false;

                        this.erraddcity = resp?.data?.message;
                        toast.error(resp.data.message);
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.addloadcity = false;
                        this.PageLoader = false;

                        this.erraddcity = resp?.data?.message;
                        toast.success(resp.data.message);
                        // this.getCity();
                        this.getContactPageList();
                        this.saved = true;
                    })
                    return
                }
                runInAction(() => {
                    this.addloadcity = false;
                    this.erraddcity = resp?.data?.message;
                    toast.error(resp.data.message);
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.PageLoader = false;

                    if (!error.response) {
                        this.addloadcity = false;
                        this.erraddcity = error?.message;
                        toast.error(error?.message);
                    }
                    if (error.response && error.response.data && error.response.data.formErrors) {
                        const formErrors = error.response.data.formErrors;
                        Object.keys(formErrors).forEach((key) => {
                            const errorMessage = formErrors[key];
                            toast.error(`${key}: ${errorMessage}`);
                        });
                    }
                    this.addloadcity = false;
                    this.erraddcity = error?.response?.data?.message;
                })
                return;
            })
    };
    // get Website type list
    getOtherPageList = () => {
        runInAction(() => {
            this.OtherPageLoader = true;
            this.errLoadWebsite = "";
            this.saved = false;
            this.nolist = false;
            this.ContactPageContent = [];
        });
        getMethodData(`/api/v1/admin/website-page/other-pages/get-list`, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.OtherPageLoader = false;
                        this.errLoadWebsite = resp?.data?.message
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.OtherPageLoader = false;
                        this.errLoadWebsite = resp?.data?.message;
                        if (resp?.data?.data.length === 0) {
                            this.nolist = true;
                        } else {
                            this.nolist = false;
                        }
                        this.OtherPageList = resp.data.data;
                        this.SetTotalPages(resp?.data?.totalPage)
                        this.saved = false;
                        // this.status = true;
                    });
                    return;
                }
                runInAction(() => {
                    this.LoadWebsite = false;
                    this.errLoadWebsite = resp?.data?.message;
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.OtherPageLoader = false;
                    if (!error.response) {
                        this.errLoadWebsite = error?.message;
                        toast.error(error?.message);
                    }
                    this.errLoadWebsite = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
    };

    //update method
    updateContactPageList = () => {
        runInAction(() => {
            this.ContactPageListLoader = true;
            this.errLoadWebsite = "";
        });

        const formData = new FormData();

        formData.append('email', this.ContactPageContent.email);
        formData.append('address', `${this.ContactPageContent.address}`);
        formData.append('mobile', this.ContactPageContent.contact);

        // formData.append('isWebsiteUpdated', false  );
        // formData.append('isLogoUpdated', true  );


        postMethodData(`/api/v1/admin/website-page/contact-info/save`,
            formData,
            this.Token
        )
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.addloadcity = false;
                        this.ContactPageListLoader = false;

                        this.erraddcity = resp?.data?.message;
                        toast.error(resp.data.message);
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.addloadcity = false;
                        this.ContactPageListLoader = false;

                        this.erraddcity = resp?.data?.message;
                        toast.success(resp.data.message);
                        // this.getCity();
                        this.getContactPageList();
                        this.saved = true;
                    })
                    return
                }
                runInAction(() => {
                    this.addloadcity = false;
                    this.erraddcity = resp?.data?.message;
                    toast.error(resp.data.message);
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.ContactPageListLoader = false;

                    if (!error.response) {
                        this.addloadcity = false;
                        this.erraddcity = error?.message;
                        toast.error(error?.message);
                    }
                    if (error.response && error.response.data && error.response.data.formErrors) {
                        const formErrors = error.response.data.formErrors;
                        Object.keys(formErrors).forEach((key) => {
                            const errorMessage = formErrors[key];
                            toast.error(`${key}: ${errorMessage}`);
                        });
                    }
                    this.addloadcity = false;
                    this.erraddcity = error?.response?.data?.message;
                })
                return;
            })
    };

    //update method
    updateWebsitePage = () => {
        runInAction(() => {
            this.ContactPageListLoader = true;
            this.errLoadWebsite = "";
        });

        const formData = new FormData();

        formData.append('email', this.ContactPageContent.email);
        formData.append('address', `${this.ContactPageContent.address}`);
        formData.append('mobile', this.ContactPageContent.contact);

        // formData.append('isWebsiteUpdated', false  );
        // formData.append('isLogoUpdated', true  );


        postMethodData(`/api/v1/admin/website-page/contact-info/save`,
            formData,
            this.Token
        )
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.addloadcity = false;
                        this.ContactPageListLoader = false;

                        this.erraddcity = resp?.data?.message;
                        toast.error(resp.data.message);
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.addloadcity = false;
                        this.ContactPageListLoader = false;

                        this.erraddcity = resp?.data?.message;
                        toast.success(resp.data.message);
                        // this.getCity();
                        this.getContactPageList();
                        this.saved = true;
                    })
                    return
                }
                runInAction(() => {
                    this.addloadcity = false;
                    this.erraddcity = resp?.data?.message;
                    toast.error(resp.data.message);
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.ContactPageListLoader = false;

                    if (!error.response) {
                        this.addloadcity = false;
                        this.erraddcity = error?.message;
                        toast.error(error?.message);
                    }
                    if (error.response && error.response.data && error.response.data.formErrors) {
                        const formErrors = error.response.data.formErrors;
                        Object.keys(formErrors).forEach((key) => {
                            const errorMessage = formErrors[key];
                            toast.error(`${key}: ${errorMessage}`);
                        });
                    }
                    this.addloadcity = false;
                    this.erraddcity = error?.response?.data?.message;
                })
                return;
            })
    };


    getFilterWebsite = () => {
        runInAction(() => {
            this.LoadWebsite = true;
            this.errLoadWebsite = "";
            this.saved = false;
            this.nolist = false;
            this.getWebsiteList = [];
        });
        postMethodData(`/api/v1/admin/Website/search?page=${this.PaginationPage}`, {
            keyword: this.filterSearch
        }, this.Token)
            .then((resp) => {

                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.loadleague = false;
                        this.errloadleague = resp?.data?.message
                    });
                    return;
                }
                if (resp?.data?.status === true) {

                    runInAction(() => {
                        this.loadcity = false;
                        this.errloadleague = resp?.data?.message;
                        if (resp?.data?.data.length === 0) {
                            this.nolist = true;
                        } else {
                            this.nolist = false;
                        }
                        this.Website = resp?.data?.data;
                        this.SetTotalPages(resp?.data?.totalPage)
                        this.saved = false;
                        // this.status = true;
                    });
                    return;
                }
                runInAction(() => {
                    this.loadcity = false;
                    this.errloadcuty = resp?.data?.message;
                });
            })
            .catch((error) => {
                runInAction(() => {
                    this.loadleague = false;
                    if (!error.response) {
                        this.errloadleague = error?.message;
                        toast.error(error?.message);
                    }
                    this.errloadleague = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
    };

    // add new Website
    addWebsitePage = () => {
        runInAction(() => {
            this.addloadWebsite = true;
            this.errLoadWebsite = "";
        });
        const formData = new FormData();

        const strippedContent = this.page_data.replace(/<[^>]*>/g, '');
        console.log(strippedContent);

        formData.append('page_name', this.pagename);
        formData.append('meta_title', this.meta);
        formData.append('meta_description', this.meta_description);
        formData.append('page_data', strippedContent);



        postMethodData("/api/v1/admin/website-page/other-pages/add", formData, this.Token).then((resp) => {
            if (resp?.data?.status === false) {
                runInAction(() => {
                    this.addloadWebsite = false;
                    this.errLoadWebsite = resp?.data?.message;
                    toast.error(resp.data.message);
                });
                return;
            }
            if (resp?.data?.status === true) {
                runInAction(() => {
                    this.addloadWebsite = false;
                    this.errLoadWebsite = resp?.data?.message;
                    // toast.success(resp.data.message);
                    this.saved = true;
                })
                return
            }
            runInAction(() => {
                this.addloadWebsite = false;
                this.errLoadWebsite = resp?.data?.message;
            });

        })
            .catch((error) => {
                runInAction(() => {
                    this.addloadWebsite = false;
                    if (!error.response) {
                        this.errLoadWebsite = error?.message;
                        toast.error(error?.message);
                    }
                    this.errLoadWebsite = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
    };

    //Active and inactive
    //Active and inactive
    statusChange = (id, type) => {
        runInAction(() => {
            this.SectionLoader = true;
            this.Sectionpopup = true;

            this.errLoadSection = "";
        });
        postMethodData(`/api/v1/admin/website-page/other-pages/update-status`, {

            "record_id": id,
            "type": type,
            "status": type == "header" ? this.header : this.footer

        }, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.Sectionid = [];
                        this.Websiteid = [];
                        this.SectionLoader = false;
                        this.Websitepopup = false;
                        this.errLoadSection = resp?.data?.message;
                        toast.error(resp?.data?.message);
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.SectionLoader = false;
                        this.Websitepopup = false;
                        this.errLoadSection = resp?.data?.message;
                        this.getOtherPageList();
                        this.Sectionid = [];
                        this.Websiteid = [];
                        toast.success(resp?.data?.message);
                    })
                    return;
                }
                runInAction(() => {
                    this.SectionLoader = false;
                    this.Websitepopup = false;

                    this.errLoadSection = resp?.data?.message;
                })
            })
            .catch((error) => {
                this.Websiteid = [];

                runInAction(() => {
                    if (!error.response) {
                        this.SectionLoader = false;
                        this.Websitepopup = false;
                        this.Sectionid = [];
                        this.errLoadSection = error?.message;
                        toast.error(error?.message);
                    }
                    toast.error(error?.response?.data?.message);
                    this.SectionLoader = false;
                    this.Websitepopup = false;
                    this.Sectionid = [];


                    this.errLoadSection = error?.response?.data?.message;
                })
                return;
            })
    };
    // Bulk Active and inactive
    BulkstatusChange = (allWebsite) => {
        runInAction(() => {
            this.WebsiteLoader = true;
            this.Websitepopup = true;

            this.errLoadWebsite = "";
        });

        postMethodData(`/api/v1/admin/Website/update-status`, {

            "branchId": JSON.stringify(allWebsite),
            "status": JSON.stringify(this.alldeactivate ? 1 : 0)

        }, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.WebsiteLoader = false;
                        this.Websitepopup = false;
                        this.errLoadWebsite = resp?.data?.message;
                        toast.error(resp?.data?.message);
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.WebsiteLoader = false;
                        this.Websitepopup = false;

                        this.errLoadWebsite = resp?.data?.message;
                        this.getFilterWebsite();
                        toast.success(resp?.data?.message);
                    })
                    return;
                }
                runInAction(() => {
                    this.WebsiteLoader = false;
                    this.Websitepopup = false;

                    this.errLoadWebsite = resp?.data?.message;
                })
            })
            .catch((error) => {
                runInAction(() => {
                    if (!error.response) {
                        this.WebsiteLoader = false;
                        this.Websitepopup = false;

                        this.errLoadWebsite = error?.message;
                        toast.error(error?.message);
                    }
                    toast.error(error?.response?.data?.message);
                    this.WebsiteLoader = false;
                    this.Websitepopup = false;

                    this.errLoadWebsite = error?.response?.data?.message;
                })
                return;
            })
    };

    //Delete method
    deletefunction = (id) => {
        runInAction(() => {
            this.setdelateLoader(true);
            this.deletepopup = true;
            this.errLoadWebsite = "";
        });
        postMethodData(`/api/v1/admin/website-page/other-pages/delete`, {

            "record_id": this.Page_id,

        }, this.Token).then((resp) => {
            if (resp?.data?.status === false) {
                runInAction(() => {
                    this.Websiteid = [];

                    this.LoadWebsite = false;
                    this.setdelateLoader(false);
                    this.deletepopup = true;
                    this.errLoadWebsite = resp?.data?.message;
                    toast.error(resp.data.message);
                });
                return;
            }
            if (resp?.data?.status === true) {
                runInAction(() => {
                    this.LoadWebsite = false;
                    this.Websiteid = [];

                    this.setdelateLoader(false);
                    this.getOtherPageList();
                    this.deletepopup = false;
                    this.errLoadWebsite = resp?.data?.message;
                    toast.success(resp.data.message);
                })
                return;
            }
            runInAction(() => {
                this.LoadWebsite = false;
                this.errLoadWebsite = resp?.data?.message;
            });

        })
            .catch((error) => {
                runInAction(() => {
                    this.addloadcity = false;
                    this.Websiteid = [];

                    if (!error.response) {
                        this.LoadWebsite = false;
                        this.setdelateLoader(false);
                        this.deletepopup = false;
                        this.errLoadWebsite = error?.message;
                        toast.error(error?.message);
                    }
                    this.LoadWebsite = false;
                    this.errLoadWebsite = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            })
    }
    // Bulk Delete 
    BulkDelete = (allWebsite) => {
        runInAction(() => {
            this.WebsiteLoader = true;
            this.Websitepopup = true;

            this.errLoadWebsite = "";
        });

        postMethodData(`/api/v1/admin/Website/multi-delete`, {

            "WebsiteId": JSON.stringify(allWebsite),
            // "status": JSON.stringify(this.alldeactivate ? 1 : 0)

        }, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.WebsiteLoader = false;
                        this.Websitepopup = false;
                        this.errLoadWebsite = resp?.data?.message;
                        toast.error(resp?.data?.message);
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.WebsiteLoader = false;
                        this.Websitepopup = false;

                        this.errLoadWebsite = resp?.data?.message;
                        this.getFilterWebsite();
                        toast.success(resp?.data?.message);
                    })
                    return;
                }
                runInAction(() => {
                    this.WebsiteLoader = false;
                    this.Websitepopup = false;

                    this.errLoadWebsite = resp?.data?.message;
                })
            })
            .catch((error) => {
                runInAction(() => {
                    if (!error.response) {
                        this.WebsiteLoader = false;
                        this.Websitepopup = false;

                        this.errLoadWebsite = error?.message;
                        toast.error(error?.message);
                    }
                    toast.error(error?.response?.data?.message);
                    this.WebsiteLoader = false;
                    this.Websitepopup = false;

                    this.errLoadWebsite = error?.response?.data?.message;
                })
                return;
            })
    };

    //get Website by id
    getWebsiteform = (id) => {
        runInAction(() => {
            this.WebsiteLoader = true;
            this.Websitepopup = true;

            this.errLoadWebsite = "";
        });
        postMethodData(`/api/v1/admin/Website/form`, {

            "record_id": id,
            // "status": JSON.stringify(this.status)

        }, this.Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                        this.WebsiteLoader = false;
                        this.Websitepopup = false;
                        this.errLoadWebsite = resp?.data?.message;
                        // toast.error(resp?.data?.message);
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        console.log(resp.data.data);
                        this.Base64WebsiteImage = resp.data.data.image_name;
                        this.WebsiteLoader = false;
                        this.Websitepopup = false;
                        this.Websitename = resp.data.data.title;
                        this.type = resp.data.data.section_id;
                        this.errLoadWebsite = resp?.data?.message;
                    })
                    return;
                }
                runInAction(() => {
                    this.WebsiteLoader = false;
                    this.Websitepopup = false;

                    this.errLoadWebsite = resp?.data?.message;
                })
            })
            .catch((error) => {
                runInAction(() => {
                    if (!error.response) {
                        this.WebsiteLoader = false;
                        this.Websitepopup = false;

                        this.errLoadWebsite = error?.message;
                        toast.error(error?.message);
                    }
                    toast.error(error?.response?.data?.message);
                    this.WebsiteLoader = false;
                    this.Websitepopup = false;

                    this.errLoadWebsite = error?.response?.data?.message;
                })
                return;
            })
    };




}




export const WebsiteStoreContext = createContext(new WebsiteStore());
export const useWebsiteStore = () => useContext(WebsiteStoreContext);
